module.exports = __webpack_public_path__ + "static/becoming-christmas-karen-00e731f62b6d23729bff096047a05936.jpg";